// this is an autogenerated file from App/Account/Content/Settings/Content/FeatureFlags/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_FeatureFlags{
  vaxiom_sys_organizations(
    order_by: { name: asc }
    where: { level: { _in: ["location", "parent"] } }
  ) {
    id
    _id
    name
    level
    application_properties(
      where: {
        message_key: {
          _in: [
            "new.reporting.default.enabled"
            "new.tasks.enabled"
            "new.generate-letters.enabled"
            "new.calendar.default.enabled"
            "new.automation-hub.comms.enabled"
            "new.leads.settings.enabled"
            "new.ai.recorder.enabled"
            "new.search.enabled"
            "new.ledger.enabled"
            "new.ledger.default.enabled"
          ]
        }
      }
    ) {
      message_key
      message_value
      organization_id
    }
  }
}

`